import { tv } from 'tailwind-variants'

export const dividerVariants = tv({
  slots: {
    divider: 'w-full h-[1px] bg-secondary-light'
  }
})
